import { render, staticRenderFns } from "./ParentOrganizationSection.vue?vue&type=template&id=7863e120&"
import script from "./ParentOrganizationSection.vue?vue&type=script&lang=js&"
export * from "./ParentOrganizationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports